import React from 'react';
import { useRecoilState } from 'recoil';
import { FilterOption } from '../../../../interfaces/filters';
import ButtonGroup from '../../../Shared/ButtonGroup';

import * as AppState from '../../../../AppState';
import Checkbox from '../../../Shared/Checkbox/Checkbox';

const parkingSpotsOption: FilterOption[] = [
	{
		label: 'Any',
		value: 0
	},
	{
		label: '1+',
		value: 1
	},
	{
		label: '2+',
		value: 2
	},
	{
		label: '3+',
		value: 3
	},
	{
		label: '4+',
		value: 4
	},
	{
		label: '5+',
		value: 5
	}
];
const ParkingSpot = () => {

	const [gsFilters, setGsFilters] = useRecoilState(AppState.gsFilters);

	return <>
		<ButtonGroup
			id="ParkingSpotButtonGroup"
			label="Parking Spots"
			wrapperClass="w-100 mt-2"
			options={parkingSpotsOption}
			callback={
				(label: string, index: number, option: FilterOption) =>
					setGsFilters(currVal => ({ ...currVal, parkingSpotMin: option.value ?? 0 }))
			}
			activeButton={gsFilters.parkingSpotMin}
		/>
		<div className='my-1'>
			<Checkbox
				id='hasGarage'
				name='hasGarage'
				onCheckedChange={(checked: boolean) => {
					setGsFilters(currVal => ({ ...currVal, hasGarage: checked }));
				}}
				label='Must have garage'
				checkedValue={gsFilters.hasGarage}
			/>
		</div>
	</>;
};

export default ParkingSpot;